var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        title: _vm.title,
        visible: _vm.isShow,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "text-form",
          attrs: { model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "商品名称:",
                "label-width": "90px",
                prop: "productname",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 7,
                  placeholder: "请输入商品名称，最多100个字",
                  maxlength: "100",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.productname,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "productname", $$v)
                  },
                  expression: "form.productname",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer text-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.saveProduct("form")
                },
              },
            },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("form")
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }